import React from 'react';
import { Zap, ShieldCheck, LayoutDashboard, Gift, BookMarked } from 'lucide-react';

const TOOLS = [
  {
    view: 'browse',
    className: 'browse',
    icon: LayoutDashboard,
    title: 'Odds Dashboard',
    tagline: 'Every line, every book',
    description: 'Live odds from all major U.S. sportsbooks side-by-side. Best available price highlighted automatically. Includes a parlay builder.',
    statKey: null,
    statLabel: null,
  },
  {
    view: 'ev',
    className: 'ev',
    icon: Zap,
    title: '+EV Finder',
    tagline: 'Beat the books long-term',
    description: 'Finds bets where the odds are mathematically in your favor. Based on sharp market consensus — place these consistently and the edge compounds over time.',
    statKey: 'evCount',
    statLabel: 'edges',
  },
  {
    view: 'arbitrage',
    className: 'arb',
    icon: ShieldCheck,
    title: 'Arbitrage Finder',
    tagline: 'Guaranteed profit, no risk',
    description: "When sportsbooks disagree enough, you can bet both sides and lock in a return no matter who wins. Calculates exact stake splits automatically.",
    statKey: 'arbCount',
    statLabel: 'arbs',
  },
  {
    view: 'promo',
    className: 'promo',
    icon: Gift,
    title: 'Promo Converter',
    tagline: 'Turn promos into real cash',
    description: 'Converts free bets, profit boosts, and deposit bonuses into guaranteed withdrawable cash via strategic hedging.',
    statKey: null,
    statLabel: null,
  },
  {
    view: 'bets',
    className: 'bets',
    icon: BookMarked,
    title: 'My Bets',
    tagline: 'Track your performance',
    description: 'Log your EV, arb, and promo bets and track your ROI and total P&L as results come in.',
    statKey: null,
    statLabel: null,
  },
];

function HomePage({ onNavigate, stats, user }) {
  const firstName = user?.user_metadata?.first_name
    || user?.user_metadata?.full_name?.split(' ')[0]
    || null;

  const evCount = stats?.evCount || 0;
  const arbCount = stats?.arbCount || 0;
  const hasLiveStats = evCount > 0 || arbCount > 0;

  return (
    <div className="home-page">

      {/* ── Dark hero ── */}
      <div className="home-hero-dark">
        <div className="home-hero-dark-inner">
          <div className="home-hero-dark-text">
            <h1 className="home-hero-dark-title">
              {firstName ? `Welcome back, ${firstName}.` : 'Your edge, updated.'}
            </h1>
            <p className="home-hero-dark-sub">
              Sharp lines refreshed every 2 minutes across all major U.S. sportsbooks.
            </p>
          </div>

          {hasLiveStats && (
            <div className="home-hero-stats">
              {evCount > 0 && (
                <div className="home-hero-stat home-hero-stat-ev">
                  <span className="home-hero-stat-num">{evCount}</span>
                  <span className="home-hero-stat-label">+EV opportunities</span>
                </div>
              )}
              {arbCount > 0 && (
                <div className="home-hero-stat home-hero-stat-arb">
                  <span className="home-hero-stat-num">{arbCount}</span>
                  <span className="home-hero-stat-label">Arbitrage bets</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* ── Tool cards ── */}
      <div className="home-tools">
        {TOOLS.map(tool => {
          const Icon = tool.icon;
          const count = tool.statKey ? stats?.[tool.statKey] : null;

          return (
            <div
              key={tool.view}
              className={`home-tool-card home-tool-${tool.className}`}
              onClick={() => onNavigate(tool.view)}
            >
              <div className="home-tool-top">
                <div className={`home-tool-icon home-tool-icon-${tool.className}`}>
                  <Icon size={22} />
                </div>
                {count > 0 && (
                  <span className={`home-tool-count home-tool-count-${tool.className}`}>
                    {count} {tool.statLabel}
                  </span>
                )}
              </div>
              <div className="home-tool-body">
                <h3 className="home-tool-title">{tool.title}</h3>
                <p className="home-tool-tagline">{tool.tagline}</p>
                <p className="home-tool-desc">{tool.description}</p>
              </div>
              <div className={`home-tool-cta home-tool-cta-${tool.className}`}>
                Open {tool.title} →
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}

export default HomePage;
